var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("WebSocket Room Test")]),_c('button',{on:{"click":_vm.sendShowImage}},[_vm._v("Bild an Room senden")]),(_vm.imageUrl)?_c('div',[_c('h3',[_vm._v("Empfangenes Bild:")]),_c('img',{staticStyle:{"max-width":"300px","margin-top":"20px"},attrs:{"src":_vm.imageUrl,"alt":"Empfangenes Bild"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }